export default "__VITE_PUBLIC_ASSET__6b08dcaa__"